import $ from 'jquery';
import translations from '../../../lang/translations';

function initialize() {
    /**
     * Select transparente, para ter nome custom na coluna
     */
    $('.compare .select').on('change', function () {
        $(this).parent().find('.select-name').html($(this).find('option:selected').html());
    });

    /**
     * Atualiza os combos com os dados conforme API
     */
    $('.compare .select-primary').on('change', fetchModels);

    $('.compare .select-data').on('change', populateModelTechs);

    //Força seleção do primeiro item da lista
    $('.compare .select').first().val($('.compare .select option').eq(1).val()).trigger('change');
}

/**
 * Popula a tabela com os modelos enviados (podem ser enviados até 3 modelos)
 */
function populateModelTechs() {
    updateSelectDisableds();

    const table = $('.compare.table-compare').first();

    const params =
        '?' +
        $('.compare .select-data')
            .toArray()
            .map((v, i) => {
                return 'model_' + i + '=' + v.value;
            })
            .join('&');

    const url = $('#comparador').data('api-models-data') + '' + params;
    $.get(url).then(function (rs) {
        table.find('.tr-data').remove(); //empty

        //Head com as imagens
        table.find('.image').each(function (k) {
            if (rs.images && rs.images[k]) {
                $(this)
                    .find('.with-image')
                    .html('<img class="w-full h-auto" src="' + rs.images[k] + '" />');
                $(this).find('.with-image').removeClass('hidden');
                $(this).find('.no-image').addClass('hidden');
            } else {
                $(this).find('.with-image').html('').addClass('hidden');
                $(this).find('.no-image').removeClass('hidden');
                $(this).find('.select-name').html(translations[window.currentLocale()].select_model);
            }
        });

        //Rows com as especificações técnicas
        var index = 0;
        Object.keys(rs.rows).map(function (slug, k) {
            let tr =
                '<tr class="tr-data"><td class="font-medium text-sm py-6 break-words text-dark3a">' +
                rs.rows[slug] +
                '</td>';

            rs.list.map(function (item) {
                tr +=
                    '<td class="font-medium text-sm break-words text-white">' +
                    (item && item[slug] ? item[slug] : '-') +
                    '</td>';
            });

            for (let i = rs.list.length; i < 3; i++) {
                tr += '<td></td>';
            }

            tr += '</tr>';

            table.append(tr);

            index += 1;
        });
    });
}
/**
 * Retorna a lista de modelos que podem ser comparáveis com a seleção do modelo da primeira coluna
 */
function fetchModels() {
    const selectSecondary = $('.compare .select-secondary');

    selectSecondary.empty();
    selectSecondary.append(new Option(translations[window.currentLocale()].select_model, ''));
    selectSecondary.attr('disabled', 'disabled');

    if (!$(this).val()) {
        return;
    }

    const url = $('#comparador').data('api-models') + '?model_id=' + $(this).val();
    $.get(url).then(function (rs) {
        selectSecondary.removeAttr('disabled');
        selectSecondary.empty();
        selectSecondary.append(new Option(translations[window.currentLocale()].select_model, ''));
        $.each(rs, function (index, item) {
            selectSecondary.append(new Option(item, index));
        });

        updateSelectDisableds();
    });
}

/**
 * Habilita/Desabilita colunas conforme seleção do modelo anterior
 */
function updateSelectDisableds() {
    const select = $('.compare.table-compare .select');

    select.each(function (k) {
        const nextSelect = select.eq(k + 1);
        const parentNextSelect = nextSelect.parent().parent();

        if (select.eq(k).val()) {
            parentNextSelect.removeClass('disabled');
        } else {
            parentNextSelect.addClass('disabled');
        }
    });
}

initialize();
